"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.jsxDEV = exports.jsxs = exports.jsx = void 0;
const setAttributes_1 = require("./setAttributes");
const utils_1 = require("./utils");
function jsx(tag, props) {
    if (typeof tag === "function")
        return tag(props);
    const { children, ...attrs } = props;
    const { finalTag, finalAttrs } = (0, utils_1.applyTsxTag)(tag, attrs);
    const element = (0, utils_1.createDomElement)(finalTag, finalAttrs);
    (0, setAttributes_1.setAttributes)(element, finalAttrs);
    (0, utils_1.applyChildren)(element, [children]);
    return element;
}
exports.jsx = jsx;
exports.jsxs = jsx;
exports.jsxDEV = jsx;
